<template>
  <div v-bind="$attrs" class="package-tag" :style="{background: packageStyle[packageType].bg}">
    <img class="tf-y-2 tag-icon" :src="packageStyle[packageType].icon"/>
    <span :style="{color: packageStyle[packageType].color}">
      <slot></slot>
    </span>
  </div>
</template>
<script setup>
defineProps({
  packageType: {
    type: String,
    default: 'formal'
  }// test, formal
})

const packageStyle = {
  test: {
    bg: '#67cbe8',
    icon: require('@/assets/images/tag.svg'),
    color:'#ffffff'
  },
  formal: {
    bg: '#caefa3',
    icon: require('@/assets/images/private.svg'),
    color: '#41af7d'
  }
}

</script>
<style lang="scss" scoped>
.package-tag{
  padding: 4px 6px;
  box-sizing: border-box;
  color:#ffffff;
  .tag-icon{
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
</style>